export const PLATFORM_TO_REGION = {
    na1: 'americas',
    br1: 'americas',
    la1: 'americas',
    la2: 'americas',
    oc1: 'americas',
    euw1: 'europe',
    eun1: 'europe',
    tr1: 'europe',
    ru: 'europe',
    me1: 'europe',
    jp1: 'asia',
    sg2: 'asia',
    tw2: 'asia',
    vn2: 'asia',
    kr: 'asia',
};

export const DISPLAY_REGION_TO_PLATFORM = {
    na: 'na1',
    euw: 'euw1',
    eun: 'eun1',
    br: 'br1',
    kr: 'kr',
    oc: 'oc1',
    lan: 'la1',
    las: 'la2',
    ru: 'ru',
    tr: 'tr1',
    me: 'me1',
    jp: 'jp1',
    sg: 'sg2',
    tw: 'tw2',
    vn: 'vn2',
};

export const PLATFORM_OPTIONS = [
    { value: '', label: 'GLOBAL' },
    { value: 'na1', label: 'NORTH AMERICA' },
    { value: 'euw1', label: 'EUROPE WEST' },
    { value: 'br1', label: 'BRAZIL' },
    { value: 'eun1', label: 'EUROPE NORDIC & EAST' },
    { value: 'kr', label: 'KOREA' },
    { value: 'oc1', label: 'OCEANIA' },
    { value: 'la1', label: 'LATIN AMERICA NORTH' },
    { value: 'la2', label: 'LATIN AMERICA SOUTH' },
    { value: 'ru', label: 'RUSSIA' },
    { value: 'tr1', label: 'TURKEY' },
    { value: 'me1', label: 'MIDDLE EAST' },
    { value: 'jp1', label: 'JAPAN' },
    { value: 'sg2', label: 'SINGAPORE' },
    { value: 'tw2', label: 'TAIWAN' },
    { value: 'vn2', label: 'VIETNAM' },
];

export const MIN_SUMMONER_GAME_NAME_LENGTH = 3;

export function formatPlatformLabel(platform) {
    return String(platform || '').replace(/[0-9]+$/, '').toUpperCase();
}

export function parseSummonerSearchInput(rawValue) {
    const query = rawValue ?? '';
    const trimmed = query.trim();
    const [gameName, tagLine = ''] = trimmed.split('#');

    return {
        query,
        gameName: gameName?.trim() || '',
        tagLine: tagLine?.trim() || '',
    };
}
